import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AppRouter } from './app/router';
import './i18n';
import './styles.css';

// AuthProvider is deliberately NOT here. It lives inside the lazily-loaded
// officer chunk, so a citizen on the public portal never loads Firebase.
const root = document.getElementById('root');
if (!root) throw new Error('#root not found');

createRoot(root).render(
  <StrictMode>
    <AppRouter />
  </StrictMode>,
);
